import React, { useCallback, useEffect, useState, useRef } from "react";

const MultiRangeSlider = ({
  min,
  max,
  onChange,
  symbol = "",
  timeRange = false,
  format = "12",
}) => {
  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);
  const minValRef = useRef(min);
  const maxValRef = useRef(max);
  const range = useRef(null);

  // Convert to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Set width of the range to decrease from the left side
  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  // Set width of the range to decrease from the right side
  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  // Get min and max values when their state changes
  useEffect(() => {
    if (timeRange) {
      onChange({ min: getTime("start"), max: getTime("end") });
    } else onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal]);

  function getTime(type) {
    const val = type === "start" ? minVal : maxVal;
    const hours24 = Math.floor(val / 60);
    const hours12 = hours24 % 12 == 0 ? 12 : hours24 % 12;
    const amORpm = hours24 < 12 ? "am" : "pm";
    const minutes = (val % 60).toString().padStart(2, "0");

    const res =
      format == "12"
        ? `${hours12}:${minutes} ${amORpm}`
        : `${hours24}:${minutes}`;

    return res;
  }

  return (
    <div className="range-container">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        onChange={(event) => {
          const value = Math.min(Number(event.target.value), maxVal - 1);
          setMinVal(value);
          minValRef.current = value;
        }}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 && "5" }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        onChange={(event) => {
          const value = Math.max(Number(event.target.value), minVal + 1);
          setMaxVal(value);
          maxValRef.current = value;
        }}
        className="thumb thumb--right"
      />

      <div className="slider">
        {timeRange ? (
          <>
            <div className="slider__left-value">{`${getTime("start")}`}</div>
            <div className="slider__right-value">{`${getTime("end")}`}</div>
          </>
        ) : (
          <>
            <div className="slider__left-value">{`${symbol}${minVal}`}</div>
            <div className="slider__right-value">{`${symbol}${maxVal}`}</div>
          </>
        )}
        {/* <>
          <div className="slider__left-value">{`${symbol}${minVal}`}</div>
          <div className="slider__right-value">{`${symbol}${maxVal}`}</div>
        </> */}
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
      </div>
    </div>
  );
};

export default MultiRangeSlider;
